<template>
    <div class="index-container">
        <div class="left-container">
            <div class="index-header">
                <img :src="'/static/img'+developer.header" class="header-img" @click="gotoCenter" alt="">
                <div class="tips">
                    <div class="welcome">亲，欢迎使用众联云打印服务</div>
                    <div class="tips-item">
                        <div class="app-info">
                            <div class="app-label">Appid</div>
                            <div>{{developer.appid}}</div>
                        </div>
                        <div :data-clipboard-text="developer.appid" class="iconfont icon-fuzhi"></div>
                    </div>
                    <div class="tips-item">
                        <div class="app-info">
                            <div class="app-label">Secret</div>
                            <div v-if="showSecret">{{developer.appSecret}}</div>
                            <div v-else>{{developer.appSecretDot}}</div>
                        </div>
                        <div :data-clipboard-text="developer.appSecret" class="iconfont icon-fuzhi"></div>
                        <div class="eye iconfont icon-guan" v-if="showSecret" @click="changeShowSecret"></div>
                        <div class="eye iconfont icon-kai" v-else @click="changeShowSecret"></div>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="info-item">
                    <div>亲，这是您第&nbsp;<font color="red">{{loginTimes}}</font>&nbsp;次登录管理后台，</div>
                    <div class="offical-link" @click="gotoLog">查看登录日志</div>
                </div>
                <div class="info-item">
                    <div>您已绑定&nbsp;<font color="red">{{printerCount}}</font>&nbsp;台设备，</div>
                    <div class="offical-link" @click="gotoPrinter">设备管理</div>
                </div>
                <div class="line"></div>
                <div class="login-logs">
                    <div class="login-log login-log-curr" v-if="logList && logList[0]">
                        <div class="login-header">
                            <div class="iconfont icon-dizhi"></div>
                            <div class="header-tips">本次登录信息：</div>
                        </div>
                        <div class="info-item">IP段：{{logList[0].ip}}</div>
                        <div class="info-item">地址：{{logList[0].address}}</div>
                        <div class="info-item">
                            时间：{{logList[0].createTime}}
                        </div>
                    </div>
                    <div class="login-log login-log-prev" v-if="logList && logList[1]">
                        <div class="login-header">
                            <div class="iconfont icon-dizhi"></div>
                            <div class="header-tips">上次登录信息：</div>
                        </div>
                        <div class="info-item">IP段：{{logList[1].ip}}</div>
                        <div class="info-item">地址：{{logList[1].address}}</div>
                        <div class="info-item">时间：{{logList[1].createTime}}</div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="shops">
                    <div class="shop-item" v-for="(item, index) in shops" :key="index" @click="gotoShop(item.link)">
                        <img class="shop-logo" :src="item.logo" alt="">
                        <div class="shop-name">{{item.name}}</div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="qrcodes">
                    <div class="qrcode-item">
                        <img src="/static/img/tech.jpg" class="qrcode" alt="">
                        <div>开发问题咨询请扫描添加上方微信</div>
                    </div>
                    <div class="qrcode-item">
                        <img src="/static/img/wx.jpg" class="qrcode" alt="">
                        <div>消息通知扫描关注“众联云助手”公众号</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-container">
            <div class="notice-container">
                <div class="title">
                    <div class="iconfont icon-gonggao"></div>
                    <div class="title-label">系统公告</div>
                </div>
                <div class="content">
                    <p>尊敬的用户：</p>
                    <p class="space">您好！</p>
                    <p class="space">
                        众联云打印服务是由广州众联云技术有限公司开发，本公司是一家专注物联网解决方案的高新科技公司，我们在万物互联的时代趋势推动下，紧跟潮流，运用最新科技成果，研发各类处于行业领先水平的智能终端，致力于满足客户的多样化需求，降低经营成本，提高生产效率。
                    </p>
                    <p class="space">
                        我们的产品有云打印机、蓝牙云盒、云喇叭等，通过众联云数据中心的数据聚合能力，结合稳定高效的WiFi/4G/5G通讯技术，实现24小时全天候不漏单智能打印和语音播报，无需手机，无需电脑，无需人工参与。众联云打印机支持多店铺绑定，来单真人语音提醒，催单提醒，退款申请提醒，个性化定制小票等功能，感谢您的支持和使用。
                    </p>
                    <p class="space">众联云打印团队在此深深感谢大家长期以来的支持与厚爱，接下来我们会更加努力，给您提供更优质更全面的服务！！</p>
                    <br />
                    <p class="space">祝商祺!</p>
                    <br />
                    <div class="yin-container">
                        <img src="/static/img/yin.png" class="yin" alt="">
                        <p class="text-right">
                            众联云打印团队
                        </p>
                        <p class="text-right">
                            2022年10月10日
                        </p>
                    </div>
                    <br />
                </div>
            </div>
            <div class="news-container">
                <div class="title">
                    <div class="iconfont icon-jiekou"></div>
                    <div class="title-label">最新动态</div>
                </div>
                <div class="content" style="padding-top: 15px;">
                    <el-timeline>
                        <el-timeline-item v-for="(activity, index) in activities" :key="index" :icon="activity.icon"
                            :type="activity.type" :color="activity.color" :timestamp=" activity.timestamp">
                            {{activity.content}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Clipboard from 'clipboard';

export default {
    data() {
        return {
            showSecret: false,
            clipboard: null,
            developer: null,
            activeName: '1',
            logList: [],
            loginTimes: 1,
            printerCount: 0,
            activities: [{
                content: '优化开放平台用户体验，全新UI欢迎体验',
                timestamp: '2022-10-10',
                type: 'primary',
                icon: 'el-icon-more'
            }, {
                content: '上线打印结果回调功能',
                timestamp: '2021-11-11',
                type: 'success'
            }, {
                content: '完成 200+开发者接入',
                timestamp: '2021-06-01'
            }, {
                content: '云平台架构升级增强稳定性',
                timestamp: '2020-11-11'
            }, {
                content: '开放平台上线',
                timestamp: '2020-10-01'
            }, {
                content: '标签机完成测试',
                timestamp: '2020-06-01'
            }, {
                content: '小票机完成测试',
                timestamp: '2020-05-01'
            }, {
                content: '云打印机完成设计评审',
                timestamp: '2020-01-01'
            }, {
                content: '官网上线',
                timestamp: '2019-11-11'
            }, {
                content: '云打印开发团队成立',
                timestamp: '2019-09-01'
            }],
            shops: [{
                logo: "/static/img/alibaba.png",
                name: "阿里巴巴官方旗舰店",
                link: "https://www.zonelink.cc/"
            }, {
                logo: "/static/img/taobao.png",
                name: "淘宝官方旗舰店",
                link: "https://www.zonelink.cc/"
            }, {
                logo: "/static/img/pdd.png",
                name: "拼多多官方旗舰店",
                link: "https://www.zonelink.cc/"
            }, {
                logo: "/static/img/jd.png",
                name: "京东官方旗舰店",
                link: "https://www.zonelink.cc/"
            }]
        }
    },
    created() {
        let loginInfoStr = sessionStorage.getItem("loginInfo");
        let loginInfo = JSON.parse(loginInfoStr);
        this.developer = loginInfo.developer;
        this.logList = loginInfo.log;
        this.loginTimes = loginInfo.loginTimes;
        this.printerCount = loginInfo.printerCount;
    },
    mounted() {
        this.clipboard = new Clipboard(".icon-fuzhi");
        this.clipboard.on("success", () => {
            this.$showSuccessMsg("亲，复制成功啦赶快去粘贴吧~");
        });
    },
    methods: {
        changeShowSecret() {
            this.showSecret = !this.showSecret;
        },
        gotoCenter() {
            this.$emit("clickMenu", 8);
        },
        gotoLog() {
            this.$emit("clickMenu", 7);
        },
        gotoPrinter() {
            this.$emit("clickMenu", 1);
        },
        gotoShop(url) {
            window.open(url, "_blank");
        }
    },
    destroyed() {
        this.clipboard.destroy();
    }
}
</script>


<style scoped>
.index-container {
    width: 100%;
    height: 100%;
    display: flex;
    padding-right: 10px;
}

.left-container {
    flex: 1;
    border: 1px solid #C0C6CC;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
}

.right-container {
    flex: 1;
    margin-left: 15px;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
}

.index-header {
    padding: 20px 30px;
    background-color: #F4F4F4;
    display: flex;
}

.header-img {
    width: 90px;
    height: 90px;
    border-radius: 10px;
    cursor: pointer;
}

.tips {
    margin-left: 15px;
    font-size: 16px;
}

.welcome {
    font-size: 20px;
    margin-bottom: 5px;
    font-weight: bold;
    user-select: none;
}

.tips-item {
    display: flex;
    align-items: center;
}

.tips-item+.tips-item {
    margin-top: 5px;
}

.app-info {
    display: flex;
    align-items: center;
}

.app-label {
    background-color: #FF6700;
    color: #fff;
    padding: 0px 10px;
    border-radius: 4px;
    margin-right: 10px;
}

.icon-fuzhi {
    margin-left: 10px;
    cursor: pointer;
}

.eye {
    margin-left: 10px;
    cursor: pointer;
}

.notice-container {
    border: 1px solid #C0C6CC;
    flex: 1;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
}

.news-container {
    border: 1px solid #C0C6CC;
    margin-top: 15px;
    flex: 1;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
}

.title {
    background-color: #F4F4F4;
    padding: 15px 20px;
    font-size: 16px;
    font-weight: bold;
    user-select: none;
    display: flex;
    align-items: center;
}

.title-label {
    margin-left: 5px;
}

.content {
    padding: 10px 0px 10px 15px;
    height: 100%;
    overflow-y: scroll;
    flex: 1;
}

.info-item {
    font-size: 14px;
    display: flex;
    align-items: center;
}

.info-item+.info-item {
    margin-top: 10px;
}

.login-logs {
    display: flex;
}

.login-log {
    flex: 1;
    padding: 15px;
    border-radius: 10px;
    color: #fff;
    margin-top: 5px;
    margin-bottom: 5px;
}

.login-header {
    padding-bottom: 10px;
    border-bottom: 1px dashed #fff;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.header-tips {
    margin-left: 5px;
}

.login-log-curr {
    background-color: #67C23A;
}

.login-log-prev {
    background-color: #F56C6C;
}

.login-log+.login-log {
    margin-left: 15px;
}

.shops {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.shop-item {
    flex: 1;
    text-align: center;
    user-select: none;
    cursor: pointer;
}

.shop-logo {
    width: 60px;
}

.shop-name {
    color: #909399;
    margin-top: 5px;
}

.offical-link {
    color: #409EFF;
    text-decoration: underline;
    cursor: pointer;
}

.line {
    border-bottom: 1px solid #E4E7ED;
    margin-top: 10px;
    margin-bottom: 10px;
}

.qrcodes {
    display: flex;
    align-items: center;
}

.qrcode-item {
    flex: 1;
    text-align: center;
}

.qrcode {
    width: 160px;
}

.space {
    text-indent: 2em;
    margin-top: 1em;
}

.yin-container {
    position: relative;
}

.yin {
    position: absolute;
    width: 80px;
    right: 10px;
    bottom: 0px;
}

.text-right {
    text-align: right;
    margin-right: 30px;
}

.el-timeline-item:last-child {
    padding-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// index.vue?aaf98882